import React from 'react'
import { UserOutlined } from '@ant-design/icons'
export const WAIT = 'wait'
export const PROCESS = 'process'
export const FINISH = 'finish'
export const defaultColor = '#3366FF'

export const defaultLocale = {
  optimal: 'óptimo',
  start: 'Comenzó',
  end: 'Terminó',
  unassigned: 'Todavía no hay un recurso asignado para esta fase.',
  phone: 'Cel:'
}
export const resourceParams = {
  container: {
    className: 'resource-card-container'
  },
  avatar: {
    icon: <UserOutlined />,
    className: 'resource-card-avatar'
  },
  button: {
    className: 'resource-card-button'
  }
}

export const stepsParams = {
  stepsDescription: {
    style: {
      width: '100%'
    }
  },

  stepTitle: (color) => ({
    strong: true,
    style: {
      color: color || '',
      textTransform: 'capitalize'
    }
  }),
  stepText: (inProgress) => (strong) => ({
    strong: strong,
    type: !inProgress ? 'secondary' : '',
    style: {
      fontSize: 12
    }
  })
}
